export const NOTIFICATION_FETCH = "@notification/NOTIFICATION_FETCH";
export const NOTIFICATION_SUCCESS = "@notification/NOTIFICATION_SUCCESS";
export const NOTIFICATION_ERROR = "@notification/NOTIFICATION_ERROR";




export const NOTIFICATION_DATA_GET = "@notification/NOTIFICATION_DATA_GET";
export const NOTIFICATION_GET = "@notification/NOTIFICATION_GET";
